import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF, StringBundle.BTF],
  strings: [
    'DV_DP_CREATE_WATCH_PARTY',
    'DV_DP_WATCH_PARTY_TOOLTIP',
    'DV_DP_WATCH_PARTY_FTUE_HEADER',
    'DV_DP_WATCH_PARTY_FTUE_BODY',
  ] as const,
}
